import './Founder.css';
import sany1 from '../../../assets/images/sany1.webp';
import ScrollableBlock from "../ScrollableBlock/ScrollableBlock";
import rafael from '../../../assets/images/rafael.webp'
import useWindowSize from '../../../assets/hooks/useWindowSize';

function Founder() {
    const window = useWindowSize()

    return (
        <ScrollableBlock>
            <div className='about-page__founder'>
                <img alt='' src={rafael} className='about-page__founder__img_rafael'></img>
                <div className='about-page__founder__info'>
                    <p className='about-page__founder__text'>
                        With a vision to share his passion with the world, Rafael founded Sany, a luxury watch reselling company that connects discerning buyers with the most exquisite timepieces. Drawing on his family’s expertise in jewelry and his own extensive knowledge of watches, Rafael has built Sany into a trusted name in the luxury watch market.
                    </p>
                    <div>
                        <p className='about-page__founder__text-author'>Rafael</p>
                        <p className='about-page__founder__text-status'>Founder of Sany</p>
                    </div>
                </div>
            </div>
            {window.width > 800 ?
                <p className="about-page__text">
                    What began as a small venture driven by a deep appreciation for fine timepieces has evolved into
                    a thriving business, giving watch enthusiasts the most sought-after brands and models.
                    At Sany, we understand that a watch is more than just a timekeeping device—it's a statement of style,
                    a piece of history, and a testament to craftsmanship. Our mission is to bring these exceptional pieces
                    to those who appreciate their value, whether you're a seasoned collector or a first-time buyer.
                </p>
                : null}
        </ScrollableBlock>
    );
}

export default Founder